var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"mb-4",attrs:{"no-gutters":"","align":"center"}},[_c('v-col',[_c('div',{staticClass:"headline"},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.showInfoIcon)?_c('InfoIcon',{on:{"onClick":_vm.handleInfoIconClick}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }